module.exports = __webpack_public_path__ + "img/search-button.0f72c980.svg";